import React, { useState, useEffect } from 'react';
import { string, bool } from 'prop-types';
import { Button } from 'TMComponents/Button';
import { v4 as uuidv4 } from 'uuid';
import { getOneLinkURL } from '..';

const AppsFlyerButton = ({ text, producttype: productType, ...rest }) => {
    const [href, setHref] = useState();

    useEffect(() => {
        /* istanbul ignore next */
        const observer = new MutationObserver((_, obs) => {
            if (window.AF_SMART_SCRIPT) {
                const clickId = uuidv4();

                const { clickURL } = getOneLinkURL(clickId, productType);
                setHref(clickURL);
                obs.disconnect();
            }
        });

        observer.observe(document, {
            childList: true,
            subtree: true
        });

        return () => observer.disconnect();
    }, [productType]);
    /* istanbul ignore next */
    return href ? (
        <Button {...rest} link={href}>
            {text}
        </Button>
    ) : null;
};

AppsFlyerButton.propTypes = {
    text: string,
    variant: string,
    whiteBackground: bool,
    producttype: string
};

AppsFlyerButton.defaultProps = {
    text: '',
    variant: 'primary'
};

export default AppsFlyerButton;
export { AppsFlyerButton };
